module.exports = __webpack_public_path__ + "static/media/TylerDurden.6923a15c.png";